'use client';

import { Fragment } from 'react';
import {
  AttributeSide,
  AttributeSideDynamic,
} from '@eliadmin/core/src/components/categories/attributes/attribute';
import { AttributeCategory } from '@eliadmin/core/src/components/categories/attributes/attribute-category';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { Card } from '@eliadmin/core/src/components/ui/card';
import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

const FilterSeparator = () => <Separator className="mx-4 w-auto last-of-type:hidden" />;

export function CategoryFilterLeft() {
  const templateSettings = useGlobalStore(state => state.templateSettings);
  const categoryTree = useCategoryStore(state => state.categoryTree);
  const category = useCategoryStore(state => state.category);
  const { t } = useTranslations();
  const clearFilter = useCategoryStore(s => s.clearFilters);

  const attributes = category.attributes?.filter(
    attribute => attribute.values?.length && attribute.name,
  );

  return (
    <Card className={cn('bg-input py-4', 'ea-category-filter-left')}>
      <div
        className={cn(
          'flex w-full flex-row items-center justify-between px-4',
          'ea-category-filter-left__expand-button',
        )}
      >
        <h2 data-ea-visual-tag="h5" className={cn('text-lg font-bold', 'ea-category-filter-left__expand-button-title')}>
          {/* {CATEGORY_CONFIG.categoryFilter.funnelIcon} */}
          {t('text566')}
        </h2>
        <Button variant="link" className="px-0" onClick={clearFilter}>
          {t('text632')}
        </Button>
        {/* add data expanded attribute */}
      </div>

      <div className={cn('ea-category-filter-left__content-wrapper')}>
        <div className={cn('flex flex-col gap-4', 'ea-category-filter-left__content')}>
          <FilterSeparator />
          {/* categories */}
          {!!templateSettings.category?.tree_list?.enabled && !!categoryTree && (
            <>
              <AttributeCategory order={templateSettings.category?.tree_list?.order} />
              <FilterSeparator />
            </>
          )}

          {/* subcategories */}
          {!!templateSettings.category?.categories_in_filter?.enabled &&
            !!category.sub_categories?.length && (
              <>
                <AttributeSide
                  name={t('text337')}
                  type="subCategory"
                  attribute={{ type: 'status', type2: 'statuses' }}
                  order={templateSettings.category?.categories_in_filter?.order}
                  className={{ wrapper: cn('', 'ea-category-filter-left__subcategories') }}
                />
                <FilterSeparator />
              </>
            )}

          {/* manufacturers */}
          {!!templateSettings.category?.manufacturers_in_filter?.enabled &&
            !!category.manufacturers?.length && (
              <>
                <AttributeSide
                  name={t('text195')}
                  type="generic"
                  attribute={{ type: 'manufacturer', type2: 'manufacturers' }}
                  order={templateSettings.category?.manufacturers_in_filter?.order}
                  className={{ wrapper: cn('', 'ea-category-filter-left__manufacturers') }}
                />
                <FilterSeparator />
              </>
            )}

          {/* statuses */}
          {!!templateSettings.category?.statuses_in_filter?.enabled &&
            !!category.statuses?.length && (
              <>
                <AttributeSide
                  name={t('text518')}
                  type="generic"
                  attribute={{ type: 'status', type2: 'statuses' }}
                  order={templateSettings.category?.categories_in_filter?.order}
                  className={{ wrapper: cn('', 'ea-category-filter-left__statuses') }}
                />
                <FilterSeparator />
              </>
            )}

          {/* availabilities */}
          {!!templateSettings.category?.availability_in_filter?.enabled &&
            !!category.availabilities?.length && (
              <>
                <AttributeSide
                  name={t('text339')}
                  type="generic"
                  attribute={{ type: 'availability', type2: 'availabilities' }}
                  order={templateSettings.category.availability_in_filter.order}
                  className={{ wrapper: cn('', 'ea-category-filter-left__availabilities') }}
                />
                <FilterSeparator />
              </>
            )}

          {/* attributes */}
          {!!templateSettings.category?.attributes_in_filter?.enabled &&
            !!category.attributes?.length && (
              // <div className={`order-${templateSettings.category.attributes_in_filter.order}`}>
              <>
                {attributes?.map((attribute, i) => (
                  <Fragment key={`attribute-${attribute.id ?? attribute.name}-${i}`}>
                    <AttributeSideDynamic
                      name={attribute.name}
                      attribute={attribute as any}
                      className={{ wrapper: cn('', 'ea-category-filter-left__attributes') }}
                    />
                    <FilterSeparator />
                  </Fragment>
                ))}
              </>
            )}

          {/* price */}
          {!!templateSettings.category?.price_in_filter?.enabled && category.price.max !== null && (
            <>
              <AttributeSide
                name={t('text340')}
                type="price"
                attribute={{ type: 'status', type2: 'statuses' }}
                order={templateSettings.category.price_in_filter.order}
                className={{ wrapper: cn('', 'ea-category-filter-left__price') }}
              />
              <FilterSeparator />
            </>
          )}

          {!!templateSettings.category?.suppliers_in_filter?.enabled &&
            !!category.suppliers?.length && (
              <>
                <AttributeSide
                  name={t('text718')}
                  type="generic"
                  attribute={{ type: 'supplier', type2: 'suppliers' }}
                  className={{ wrapper: cn('', 'ea-category-filter-left__suppliers') }}
                  order={templateSettings.category.suppliers_in_filter.order}
                />
                <FilterSeparator />
              </>
            )}
          {!!templateSettings.category?.suppliers_location_in_filter?.enabled && (
            <>
              <AttributeSide
                name={t('text728')}
                type="supplierLocation"
                attribute={{ type: 'supplier', type2: 'suppliers' }}
                className={{ wrapper: cn('', 'ea-category-filter-sheet__suppliers_location') }}
                order={templateSettings.category?.suppliers_in_filter?.order}
              />
              <FilterSeparator />
            </>
          )}
        </div>
      </div>
    </Card>
  );
}
